import * as Yup from "yup";
import { UpdateEmployeeServiceRelationsOptionsType } from "@me-team/host/main/graphql/types";
import { TFunction } from "i18next";
import {
    ServiceProviderSettingsFormValues,
    ServiceProviderUpdateOption,
} from "../ServiceProviderSettingsModal/ServiceProviderSettingsModal";

export const getServiceProviderSettingsValidationSchema = (
    t: TFunction,
    hasDurationChanges: boolean,
    hasPriceChanges: boolean,
    hasOnlineChanges: boolean
): Yup.ObjectSchema<ServiceProviderSettingsFormValues> => {
    const durationAndPriceAllowed: readonly ServiceProviderUpdateOption[] = [
        UpdateEmployeeServiceRelationsOptionsType.SetAbsolute,
        UpdateEmployeeServiceRelationsOptionsType.AddDelta,
        "KEEP_OLD_VALUE",
    ];

    const onlineAllowed: readonly ServiceProviderUpdateOption[] = [
        UpdateEmployeeServiceRelationsOptionsType.SetAbsolute,
        "KEEP_OLD_VALUE",
    ];

    const requiredMessage = t("validation.required");

    const shape: Partial<
        Record<
            keyof ServiceProviderSettingsFormValues,
            Yup.StringSchema<ServiceProviderSettingsFormValues[keyof ServiceProviderSettingsFormValues]>
        >
    > = {};

    if (hasDurationChanges) {
        shape.durationOption = Yup.string<ServiceProviderSettingsFormValues["durationOption"]>()
            .required(requiredMessage)
            .oneOf(durationAndPriceAllowed);
    }

    if (hasPriceChanges) {
        shape.priceOption = Yup.string<ServiceProviderSettingsFormValues["priceOption"]>()
            .required(requiredMessage)
            .oneOf(durationAndPriceAllowed);
    }

    if (hasOnlineChanges) {
        shape.onlineOption = Yup.string<ServiceProviderSettingsFormValues["onlineOption"]>()
            .required(requiredMessage)
            .oneOf(onlineAllowed);
    }

    return Yup.object(shape).defined() as Yup.ObjectSchema<ServiceProviderSettingsFormValues>;
};
